
  <!-- Scroll To Top -->
  <div class="scrollToTop" (click)="taptotop()" [ngStyle]="{ display: show ? 'flex' : 'none' }" style="display: flex" >
    <span class="arrow"><i class="ti ti-caret-up text-xl"></i></span>
  </div>
  <div id="responsive-overlay"></div>
  <!-- Scroll To Top -->

